import { ApolloClient } from '@apollo/client';
import {
  EntityCounts,
  RawProperty,
  Relationship,
} from '@jupiterone/query-language-autocomplete';
import {
  FetchEntityCounts,
  J1ApolloClient,
} from '@jupiterone/jupiter-web-toolkit';
import gql from 'graphql-tag';

export type QueryPropertiesForMultipleSourcesResult = {
  queryPropertiesForMultipleSources: {
    [key: string]: RawProperty[];
  };
};

export type QueryPropertiesResult = {
  queryProperties: RawProperty[];
};

export const QueryProperties = gql`
  query QueryProperties($entity: String) {
    queryProperties(entity: $entity) {
      id
      accountId
      entity
      name
      valueType
      count
    }
  }
`;

export type QueryAllPropertiesResult = {
  queryProperties: RawProperty[];
};

export const QueryAllProperties = gql`
  query QueryProperties($entity: String) {
    queryProperties(entity: $entity) {
      id
      accountId
      name
      valueType
      count
    }
  }
`;

export const QueryPropertiesForMultipleSources = gql`
  query QueryPropertiesForMultipleSources($entitySources: [String!]!) {
    queryPropertiesForMultipleSources(entitySources: $entitySources)
  }
`;

export const QueryRelationships = gql`
  query QueryRelationships($sourceEntity: String) {
    queryRelationships(sourceEntity: $sourceEntity) {
      sourceEntity
      targetEntity
      name
      count
    }
  }
`;

export type QueryRelationshipsForMultipleSourcesResult = {
  queryRelationshipsForMultipleSources: {
    [key: string]: Relationship[];
  };
};
export const QueryRelationshipsForMultipleSources = gql`
  query QueryRelationshipsForMultipleSources($sourceEntities: [String!]!) {
    queryRelationshipsForMultipleSources(sourceEntities: $sourceEntities)
  }
`;

const entityCounts = async (
  client: ApolloClient<any> = J1ApolloClient.shared()
): Promise<EntityCounts> => {
  const { data } = await client.query({
    query: FetchEntityCounts,
    fetchPolicy: 'network-only',
  });

  return data.allEntityCounts;
};

const properties = async (
  client: ApolloClient<any> = J1ApolloClient.shared(),
  entity?: string
): Promise<RawProperty[]> => {
  const { data } = await client.query({
    query: QueryProperties,
    variables: entity ? { entity } : {},
    fetchPolicy: 'cache-first',
  });

  return data.queryProperties;
};

const relationships = async (
  client: ApolloClient<any> = J1ApolloClient.shared(),
  sourceEntity?: string
): Promise<Relationship[]> => {
  const { data } = await client.query({
    query: QueryRelationships,
    variables: { sourceEntity },
    fetchPolicy: 'cache-first',
  });

  return data.queryRelationships;
};

const autocompleteApi = {
  entityCounts,
  properties,
  relationships,
};

export default autocompleteApi;
